import { HandleEvents } from './handleEvents.js';
import { on, _global } from '../utils/unils.js';
import { isInBrowser } from '../utils/isInBrowser.js';
import { openWhiteScreen } from './whiteScreen.js';
import { options } from './option.js';
import { WebResourceTime } from './resourceTime.js';

function stepInit(config) {
    if (!isInBrowser())
        return;
    // 错误&资源处理
    on(_global, 'error', function (e) {
        HandleEvents.handleError(e);
    }, true);
    // promise 错误
    on(_global, 'unhandledrejection', function (e) {
        HandleEvents.unhandRejection(e);
    });
    // 性能检测上报
    HandleEvents.handlePerformance();
    //开启白屏检测
    if (config === null || config === void 0 ? void 0 : config.whiteScreen) {
        try {
            openWhiteScreen(config.whiteScreen);
        }
        catch (error) {
            console.error('bili-mirror: whiteScreen错误解析异常:', error);
        }
    }
    // 是否开启资源监听
    if (options.config['resource-time'] && Object.keys(options.config['resource-time']).length) {
        on(_global, 'load', function () {
            const webResource = new WebResourceTime();
            try {
                webResource.on();
            }
            catch (error) {
                webResource.destroy();
                console.warn('bili-mirror:resource-watch error', error);
            }
        });
    }
}

export { stepInit };
